import apiClient from './apiClient';

export interface ChurnFeedbackItem {
  id: number;
  type: 'account_deletion' | 'subscription_cancel';
  reason: string;
  detail?: string;
  userId?: number;
  userEmail?: string;
  subscriptionPlan?: string;
  createdAt: string;
}

export interface ChurnStats {
  deletion: { reason: string; count: string }[];
  cancel: { reason: string; count: string }[];
  monthlyTrend: { type: string; month: string; count: string }[];
}

export interface ChurnListResponse {
  items: ChurnFeedbackItem[];
  total: number;
  page: number;
  totalPages: number;
}

export const churnApi = {
  getList: (params: {
    type?: string;
    page?: number;
    limit?: number;
    startDate?: string;
    endDate?: string;
  }) =>
    apiClient.get<{ success: boolean; data: ChurnListResponse }>('/admin/churn', { params }),

  getStats: (params?: { startDate?: string; endDate?: string }) =>
    apiClient.get<{ success: boolean; data: ChurnStats }>('/admin/churn/stats', { params }),
};
